import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import sqlcode_icon from "../../../Assets/svgs/sql-server.svg";
import styles from "./SqlQueryComponent.module.css";
import { Tooltip } from "@mui/material";

const SqlDrawer = ({ msg }: any) => {
  const [open, setOpen] = useState(false);
  const [sqlQuery, setSqlQuery] = useState("");
  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };
  const errorTraced = msg.errorStatus;
  useEffect(() => {
    if (msg && msg?.agent_metadata[0] && msg?.agent_metadata[0]?.sql) {
      const sql_array = msg?.agent_metadata[0]?.sql;
      const sql_query = sql_array[sql_array.length - 1].tool_input.query
        ? sql_array[sql_array.length - 1].tool_input.query
        : "";
      setSqlQuery(sql_query);
    }
  }, []);

  const DrawerList = (
    <Box
      className={styles.drawer}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <span className="flex-align-items-center-space-between">
        <h5>SQL Code</h5>
        <span className="f12px">{msg.response_time_in_seconds} sec</span>
      </span>
      <div>{sqlQuery}</div>

    </Box>
  );
  return (
    <div style={{ display: errorTraced === 500 ? "none" : "inline" }}>
      <button onClick={toggleDrawer(true)}>
        <Tooltip title="Generate SQL" placement="top">
          <img src={sqlcode_icon} alt="sql icon" style={{ maxHeight: "16px", maxWidth: "16px", marginRight: "5px", color: "blue" }} />
        </Tooltip>
      </button>
      <Drawer open={open} onClose={toggleDrawer(false)} anchor={"right"}>
        {DrawerList}
        <div className={styles.copyBtn}>
          <button onClick={() => navigator.clipboard.writeText(sqlQuery)}>
            Copy
          </button>
        </div>
      </Drawer>
    </div>
  );
};

export default React.memo(SqlDrawer);
